const _temp0 = require("./location_headers/jpn_mharuna_1.png");
const _temp1 = require("./location_headers/jpn_tokyo_shutoko_2.png");
const _temp2 = require("./location_headers/jpn_tokyo_shutoko_4.png");
const _temp3 = require("./location_headers/location_header.png");
const _temp4 = require("./location_headers/spa_barcelona_bowl_multiplayer.png");
const _temp5 = require("./location_headers/spa_barcelona_gracia_1.png");
const _temp6 = require("./location_headers/spa_barcelona_gracia_2.png");
const _temp7 = require("./location_headers/spa_barcelona_gracia_5.png");
const _temp8 = require("./location_headers/spa_barcelona_oval_1.png");
const _temp9 = require("./location_headers/spa_barcelona_oval_2.png");
const _temp10 = require("./location_headers/uk_brighton_1.png");
const _temp11 = require("./location_headers/uk_brighton_2.png");
const _temp12 = require("./location_headers/uk_brighton_3.png");
const _temp13 = require("./location_headers/uk_brighton_multiplayer.png");
const _temp14 = require("./location_headers/uk_london_hackney_1.png");
const _temp15 = require("./location_headers/uk_london_hackney_2.png");
const _temp16 = require("./location_headers/uk_london_hackney_4.png");
const _temp17 = require("./location_headers/usa_amboy_1.png");
const _temp18 = require("./location_headers/usa_amboy_3.png");
const _temp19 = require("./location_headers/usa_amboy_bowl.png");
const _temp20 = require("./location_headers/usa_la_downtown_1.png");
const _temp21 = require("./location_headers/usa_la_downtown_4.png");
const _temp22 = require("./location_headers/usa_la_downtown_6.png");
const _temp23 = require("./location_headers/usa_la_downtown_figureof8.png");
const _temp24 = require("./location_headers/usa_la_longbeach_multiplayer_1.png");
const _temp25 = require("./location_headers/usa_la_longbeachdocks_2.png");
const _temp26 = require("./location_headers/usa_la_longbeachdocks_3.png");
const _temp27 = require("./location_headers/usa_la_multiplayer_highrise.png");
const _temp28 = require("./location_headers/usa_la_observatory_1.png");
const _temp29 = require("./location_headers/usa_la_observatory_2.png");
const _temp30 = require("./location_headers/usa_la_river_3.png");
const _temp31 = require("./location_headers/usa_la_river_6.png");
const _temp32 = require("./location_headers/usa_ny_dumbo_2.png");
const _temp33 = require("./location_headers/usa_ny_dumbo_3.png");
const _temp34 = require("./location_headers/usa_sanfran_russianhill_1.png");
const _temp35 = require("./location_headers/usa_sanfran_sausalito_1.png");
const _temp36 = require("./location_headers/usa_sanfran_sausalito_2.png");
module.exports = {
  "jpn_mharuna_1": _temp0,
  "jpn_tokyo_shutoko_2": _temp1,
  "jpn_tokyo_shutoko_4": _temp2,
  "location_header": _temp3,
  "spa_barcelona_bowl_multiplayer": _temp4,
  "spa_barcelona_gracia_1": _temp5,
  "spa_barcelona_gracia_2": _temp6,
  "spa_barcelona_gracia_5": _temp7,
  "spa_barcelona_oval_1": _temp8,
  "spa_barcelona_oval_2": _temp9,
  "uk_brighton_1": _temp10,
  "uk_brighton_2": _temp11,
  "uk_brighton_3": _temp12,
  "uk_brighton_multiplayer": _temp13,
  "uk_london_hackney_1": _temp14,
  "uk_london_hackney_2": _temp15,
  "uk_london_hackney_4": _temp16,
  "usa_amboy_1": _temp17,
  "usa_amboy_3": _temp18,
  "usa_amboy_bowl": _temp19,
  "usa_la_downtown_1": _temp20,
  "usa_la_downtown_4": _temp21,
  "usa_la_downtown_6": _temp22,
  "usa_la_downtown_figureof8": _temp23,
  "usa_la_longbeach_multiplayer_1": _temp24,
  "usa_la_longbeachdocks_2": _temp25,
  "usa_la_longbeachdocks_3": _temp26,
  "usa_la_multiplayer_highrise": _temp27,
  "usa_la_observatory_1": _temp28,
  "usa_la_observatory_2": _temp29,
  "usa_la_river_3": _temp30,
  "usa_la_river_6": _temp31,
  "usa_ny_dumbo_2": _temp32,
  "usa_ny_dumbo_3": _temp33,
  "usa_sanfran_russianhill_1": _temp34,
  "usa_sanfran_sausalito_1": _temp35,
  "usa_sanfran_sausalito_2": _temp36
}